import React from "react";
import { Customers } from "components/logos";
import { sectionSpacingY } from "components/section";
import { type Customer } from "lib/sanity";
import { useWarehouseCdp } from "contexts/warehouse-cdp-context";

type Props = {
  customers: Customer[];
};

export function WarehouseCustomers({ customers }: Props) {
  const { warehouse } = useWarehouseCdp();

  return (
    <Customers
      my={0}
      pt={sectionSpacingY}
      customers={customers}
      title={`The world’s most innovative companies choose Hightouch and ${warehouse.name} as their Composable CDP`}
    />
  );
}
